/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Spin,
  Typography,
  Layout,
  message,
  Divider,
  Grid,
} from 'antd';
import styled from 'styled-components';
import { useQueryMultiple } from 'hooks/useQuery';
import { getTramiteByFolio } from 'api/tramites/tramites';
import gettersMap, { getTipoDePadronPorContenType } from 'utils/padrones';
import { getPadronKey } from 'utils/padronesToString';
import { getCiudadanoPublic } from 'api/cuentaunicasir';
import { useSelector } from 'react-redux';

const estadosGlobalesDeTramites = [
  {
    id: 2,
    descripcion: 'En proceso',
  },
  {
    id: 4,
    descripcion: 'Finalizado',
  },
  {
    id: 5,
    descripcion: 'Cancelado',
  },
];

const ENV_NAME = process.env.REACT_APP_ENV_NAME || 'migob';
// eslint-disable-next-line import/no-dynamic-require
const bg = require(`../../assets/${ENV_NAME}/bg.png`);

const ValidacionDeTramites = () => {
  const padrones = useSelector((state) => state.catalogs.padrones);
  const {
    folioTRM,
    referencia_de_impresion,
  } = useQueryMultiple(['folioTRM', 'referencia_de_impresion']);
  const screens = Grid.useBreakpoint();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();

  const concatNames = (values) => {
    if (values.nombre_completo) return values.nombre_completo;
    return `${values?.nombre} ${values?.apellido_paterno
      || ''} ${values?.apellido_materno
      || ''}`;
  };

  // eslint-disable-next-line consistent-return
  const retrievePadronPublic = async (id, object_id_padron) => {
    const _padrones = await gettersMap[id]({ id: object_id_padron });
    if (_padrones) return getPadronKey(_padrones, id, true);
  };

  // eslint-disable-next-line consistent-return
  const retrieveCiudadano = async (id) => {
    setLoading(true);
    if (id) {
      const _ciudadano = await getCiudadanoPublic(id?.id || id);
      if (_ciudadano) {
        const nombreCompleto = concatNames(_ciudadano);
        return nombreCompleto;
      }
      message.info('No se encontró ciudadano');
    }
    setLoading(false);
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (padrones && padrones.length > 0) {
      let mounted = true;
      let padronString = '';
      const fetchAll = async () => {
        setLoading(true);
        const _getTramite = await getTramiteByFolio(...folioTRM, ...referencia_de_impresion);
        if (!_getTramite) {
          message.info('No se encontró el trámite');
          setLoading(false);
          return;
        }
        const _getEstadosGlobales = estadosGlobalesDeTramites.find((e) => e.id === _getTramite.estados_globales).descripcion;

        if (!_getTramite.content_type_a_padron) {
          _getTramite.tipo_padron = 'No aplica';
        } else {
          const tipoDePadron = await getTipoDePadronPorContenType(_getTramite.content_type_a_padron);
          padronString = await retrievePadronPublic(tipoDePadron, _getTramite.object_id_padron);
          padronString = `${padrones.find((padron) => padron.id === tipoDePadron).descripcion}: ${padronString}`;
        }

        if (mounted) {
          const ciudadano = await retrieveCiudadano(_getTramite?.ciudadano);
          _getTramite.estados_globales = _getEstadosGlobales;
          _getTramite.ciudadano = ciudadano;
          _getTramite.tipo_padron = padronString;
          setData(_getTramite);
          setLoading(false);
        }
      };

      fetchAll();
      return () => { mounted = false; };
    }
  }, [padrones]);

  return (
    <Spin spinning={loading} tip="Cargando...">
      <Content style={{ backgroundPosition: screens.md ? 'center 0' : '' }}>
        <Row justify="center" align="middle" style={{ height: '100vh' }}>
          <Card xs={22} sm={22} md={18} lg={14} xl={12} style={{ height: 'auto' }}>
            <CardHeader>
              <Typography.Title level={4}>
                {`${data ? 'Información' : 'Búsqueda'} del Trámite`}
              </Typography.Title>
            </CardHeader>
            <CardContent style={{ paddingLeft: screens.md ? '2vw' : 15, paddingRight: screens.md ? '2vw' : 15 }}>
              <Row justify="space-between" className="info">
                <Col xs={24} md={11} span={11}>
                  <Label>Folio:</Label>
                  <Value>{data?.folio}</Value>
                </Col>
                <Col xs={24} md={11} span={11}>
                  <Label>Fecha:</Label>
                  <Value>{data?.fecha_de_inicio}</Value>
                </Col>
                {screens.md && <Divider />}
                <Col xs={24} md={11} span={11}>
                  <Label>Trámite:</Label>
                  <Value>{data?.descripcion}</Value>
                </Col>
                <Col xs={24} md={11} span={11}>
                  <Label>Solicitante:</Label>
                  <Value>{data?.ciudadano}</Value>
                </Col>
                {screens.md && <Divider />}
                <Col xs={24} md={11} span={11}>
                  <Label>Padrón:</Label>
                  <Value>{data?.tipo_padron}</Value>
                </Col>
                {screens.md && <Divider type="vertical" />}
                <Col xs={24} md={11} span={11}>
                  <Label>Estado:</Label>
                  <Value>{data?.estados_globales}</Value>
                </Col>
                <br />
              </Row>
            </CardContent>
          </Card>
        </Row>
      </Content>
    </Spin>
  );
};

const Content = styled(Layout.Content)`
  background-size: cover;
  background-image: url(${bg});
  min-height: 100vh;
`;

const CardHeader = styled.div`
  background-color: #5D575B;
  padding: 15px 0;
  text-align: center;
  .ant-typography {
    color: #FFFFFF;
  }
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const Card = styled(Col)`
  background-color: #FFFFFF;
  border-radius: 8px;
`;

const CardContent = styled.div`
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  .info .ant-col {
    margin: 10px 0;
  }
  .ant-divider {
    margin: 0;
    border-top: 1px solid #DDDDDD;
  }
  .ant-divider-vertical {
    border-left: 1px solid #DDDDDD;
    height: calc(4em - 10px);
    margin: 5px;
  }
`;

const Label = styled(Typography.Text)`
  color: #8D8D8D;
  size: 13px;
  display: block;
`;

const Value = styled(Typography.Text)`
  color: #000000;
  size: 15px;
`;

export default ValidacionDeTramites;
